import $http from "@/plugins/axios";

export default {
  state: {
    all_data: [],
    createResponse: [],
    all_response: {},
  },
  getters: {
    all_data: (state) => state.all_data,
    createResponse: (state) => state.createResponse,
    all_response: (state) => state.all_response,
  },
  actions: {
    async getList({ commit }, path) {
      const response = await $http.get(path);
      commit("SET_ITEMS", response.data);
      return response;
    },

    async create({ commit }, params) {
      const response = await $http.post(params.path, params.form);
      commit("CREATE", response.data);
      commit("SET_RESPONSE", response);
      return response;
    },

    async update({ commit }, params) {
      const response = await $http.post(params.path, params.form);
      commit("UPDATE", response.data.data);
      commit("SET_RESPONSE", response);
    },
    async put({ commit }, params) {
      const response = await $http.put(params.path, params.form);
      commit("SET_RESPONSE", response);
      commit("PUT", response.data.data);
    },

    async delete({ commit }, path) {
      const response = await $http.delete(path);
      commit("DELETE", "delete");
    },
    async clearCache({ commit }) {
      return commit;
    },
  },
  mutations: {
    SET_ITEMS(state, data) {
      state.all_data = data;
    },
    CREATE(state, data) {
      state.createResponse = data;
    },
    UPDATE(state, data) {
      if (!Array.isArray(state.all_data.data)) return;
      state.all_data.data = state.all_data.data.map(
        (item) => (item = item.id == data.id ? data : item)
      );
    },
    DELETE(state, id) {
      state.all_data;
    },
    PUT(state, id) {
      state.all_data;
    },
    CLEAR_CACHE(state) {
      state.all_data = [];
    },
    SET_RESPONSE(state, response) {
      state.all_response = response;
    },
  },
};
